import React, { useState, useContext, useEffect } from "react"
import LoginView from "./loginView"
import { HorizontalSpacer } from "@omnichannel/ace-b2b-elements"
import PageBodyWrapper from "./pageBodyWrapper"
import ToggleButton from "./toggleButton"
// import UrlParamsContext from "../../context/UrlParamsContext"
import { APP_ID, HOMEPAGE_WEB_BASE_URL } from "../../helpers/constants"
import { navigate } from "gatsby"

const Login = _ => {
  const [toggleDisabled, setToggleDisabled] = useState(false)
  const [appId, setAppId] = useState(APP_ID)
  // const urlParams = useContext(UrlParamsContext)
  const redirectUrl = ''//(urlParams && urlParams.redirectUrl && decodeURIComponent(urlParams.redirectUrl)) || HOMEPAGE_WEB_BASE_URL

  // useEffect(() => {
  //   setAppId(urlParams?.appId)
  // }, [urlParams])

  return (
    <PageBodyWrapper
    // title="Login"
    >
      <HorizontalSpacer />
      <ToggleButton
        disabled={toggleDisabled}
        leftToggle={{
          label: "Login",
          selected: true,
        }}
        rightToggle={{
          label: "Sign Up",
          onToggle: () => { }
          // navigate(
          //   `/sign-up${redirectUrl ? `?redirectUrl=${encodeURIComponent(redirectUrl)}&appId=${appId}` : ""}`
          // ),
        }}
      />
      <HorizontalSpacer />
      <LoginView
        selected
        onLoginStarted={() => setToggleDisabled(true)}
        onLoginFinished={() => setToggleDisabled(false)}
        onFacebookLogin={() => setToggleDisabled(true)}
        onGoogleLogin={() => setToggleDisabled(true)}
        onAppleLogin={() => setToggleDisabled(true)}
      />
    </PageBodyWrapper>
  )
}

export default Login
